<div class="qrcode-section">
    @if (sidebarCollapsed) {
    <button nz-button nzType="default" (click)="openQrCodeModal()" nz-tooltip nzTooltipPlacement="right"
        [nzTooltipOverlayStyle]="{ 'margin-left': '1.5rem' }" [nzTooltipColor]="derichebourgColorBlue"
        [nzTooltipTitle]="'nav.codeQRTooltip' | translate">
        <span nz-icon nzType="qrcode" nzTheme="outline"></span>
    </button>

    <nz-modal [(nzVisible)]="isVisible" [nzTitle]="'nav.codeQR' | translate" [nzContent]="modalContent"
        (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
    </nz-modal>

    <ng-template #modalContent>
        <div class="modal-content">
            <nz-qrcode [nzValue]="url"></nz-qrcode>
        </div>
    </ng-template>
    } @else {
    <p>{{ 'nav.codeQR' | translate }}</p>
    <nz-qrcode [nzValue]="url" nzSize="100"></nz-qrcode>
    }
</div>